/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResourcesAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ResourcesAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/ResourcesAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft="auto"
 alignSelf="flex-end"
 size="small"
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Resources/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Resources/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Resources"
/>
)}
</TysiaButton>
)}
</SupportOnly>
{children}
</React.Fragment>)
}